import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../icon/icon.module'
import {
  CardBodyComponent,
  CardComponent,
  CardContentComponent,
  CardFooterComponent,
  CardGroupComponent,
  CardHeadingBodyComponent,
  CardHeadingBodyRightComponent,
  CardHeadingComponent,
  CardImgContainerComponent,
  CardImgOverlayComponent,
  CardRowComponent,
  CardSpotlightContainerComponent,
  CardRibbonComponent,
  CardRibbonIconComponent
} from './card.component';

@NgModule({
  imports: [CommonModule, IconModule],

  declarations: [
    CardBodyComponent,
    CardComponent,
    CardContentComponent,
    CardFooterComponent,
    CardGroupComponent,
    CardHeadingBodyComponent,
    CardHeadingBodyRightComponent,
    CardHeadingComponent,
    CardImgContainerComponent,
    CardImgOverlayComponent,
    CardRowComponent,
    CardSpotlightContainerComponent,
    CardRibbonComponent,
    CardRibbonIconComponent
  ],
  exports: [
    CardBodyComponent,
    CardComponent,
    CardContentComponent,
    CardFooterComponent,
    CardGroupComponent,
    CardHeadingBodyComponent,
    CardHeadingBodyRightComponent,
    CardHeadingComponent,
    CardImgContainerComponent,
    CardImgOverlayComponent,
    CardRowComponent,
    CardSpotlightContainerComponent,
    CardRibbonComponent,
    CardRibbonIconComponent
  ]
})
export class CardModule {}
